import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import Flex from '@client/components/flex/Flex';
import { selectFundraiserTypes } from '@client/redux/fundraiser/fundraiserSelectors';
import {
  getSearchParams,
  getSearchQueryValue,
} from '@client/shared/utils/urlUtils/urlUtils';
import { trackCustomEvent } from '@client/tracking/GTM';
import {
  EVENT_GA,
  CATEGORY_SEARCH,
  ACTION_BTN_CLICK,
} from '@client/definitions/tracking';
import { SEARCH } from '@client/definitions/constants';
import styles from './searchFundraisers.scss';

function SearchFundriasers({ location, history }) {
  const [inputValue, setInputValue] = useState(
    getSearchQueryValue(location.search, 'SearchTerm') || ''
  );

  const defaultValueSelect =
    getSearchQueryValue(location.search, 'FundraiserType') || '1';

  const [showResetSearchFieldBtn, setShowResetSearchFieldBtn] = useState(
    !!inputValue
  );

  useEffect(() => {
    if (inputValue === '') {
      setShowResetSearchFieldBtn(false);
    } else {
      setShowResetSearchFieldBtn(true);
    }
  }, [inputValue]);

  function onInputSubmit(event) {
    if (event) {
      event.preventDefault();
    }

    const searchTest = getSearchParams(location, {
      addParamsObj: { SearchTerm: inputValue },
      removeParamsArray: ['page'],
    });

    history.push({
      search: searchTest,
    });

    trackCustomEvent(EVENT_GA, {
      click_category: CATEGORY_SEARCH,
      click_type: ACTION_BTN_CLICK,
      click_text: SEARCH,
    });
  }

  function onClearSearch() {
    setInputValue('');
    const searchTest = getSearchParams(location, {
      removeParamsArray: ['SearchTerm'],
    });
    history.push({ search: searchTest });
  }

  function onChangeInput(event) {
    setInputValue(event.target.value);
  }

  return (
    <form
      className={`${styleHelper.layoutMobileAndTabletSidePadding} ${styles.searchFundraisers}`}
      onSubmit={onInputSubmit}
    >
      <Flex
        className={`${styles.searchContainer}`}
        flexNr={1}
        alignCenter
        spaceBetween
      >
        <Flex className={styles.inputWrapper}>
          <input
            placeholder={'Hitta insamling'}
            className={styles.input}
            value={inputValue}
            onChange={onChangeInput}
          />
          {showResetSearchFieldBtn && (
            <button
              className={styles.btnClear}
              type={'button'}
              onClick={onClearSearch}
            >
              <svg
                className={styles.crossIcon}
                height="30"
                width="30"
                viewBox="0 0 30 30"
              >
                <path
                  className={styles.cross1}
                  d={'M 2 15 L 28 15'}
                  strokeWidth={'3'}
                />
                <path
                  className={styles.cross2}
                  d={'M 2 15 L 28 15'}
                  strokeWidth={'3'}
                />
              </svg>
            </button>
          )}
        </Flex>
      </Flex>
      <input
        className={`${styleHelper.btnPrimaryLg} ${styles.btnSubmit}`}
        type={'submit'}
        value={SEARCH}
      />
    </form>
  );
}

SearchFundriasers.propTypes = {
  fundraiserTypes: ImmutablePropTypes.list,
  onSearchFundraiser: PropTypes.func,
  onSelectCategory: PropTypes.func,
  location: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    fundraiserTypes: selectFundraiserTypes(state),
  };
}

export default connect(mapStateToProps)(SearchFundriasers);
